import { Injectable } from "@angular/core";
import {
	AcepSSOService,
	GlobalDomOpsService,
	GlobalDataOpsService,
	CommonOperationsService
} from "@acepteam/globalspack";
import { MemberAppDomService, MemberAppDataService } from "../../services";
import {
	DomService,
	DataService,
	HelperService,
	LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { PersonalInformationDetails } from "../../../shared/models";
import { of } from "rxjs";
import { tap } from "rxjs/operators";
import { AbstractControl } from "@angular/forms";
import { CustomerAddress } from "../../../shared/models/my-account-data.models";

@Injectable({
	providedIn: "root"
})
export class PersonalInfoService {
	constructor(
		private ssoService: AcepSSOService,
		private globalDomOpsService: GlobalDomOpsService,
		private memberAppDomService: MemberAppDomService,
		private memberAppDataService: MemberAppDataService,
		private domService: DomService,
		private globalDataOpsService: GlobalDataOpsService,
		private dataService: DataService,
		private myAccountDataService: MyAccountDataOpsService,
		private commonOpsService: CommonOperationsService,
		private helperService: HelperService,
		private loggerService: LoggerService,
		private http: HttpClient
	) {}

	public retireAge: number = 55;
	get contactAge(): number {
		return this.myAccountDataService.myaccountdata.primaryContact.personalinfo.age;
	}

	GetAddressByAddressType(addressType: string): CustomerAddress {
		let ca: CustomerAddress;
		if (addressType == "Home") {
			ca = this.memberAppDataService.memberAppData.addresses.home;
		} else if (addressType == "Hospital") {
			ca = this.memberAppDataService.memberAppData.addresses.hospital;
		} else if (addressType == "Business") {
			ca = this.memberAppDataService.memberAppData.addresses.business;
		}

		return ca;
	}

	GetPhoneByPhoneType(phoneType: string): string {
		let ph: string = "";
		if (phoneType == "Home") {
			ph = this.memberAppDataService.memberAppData.phones.homephone;
		} else if (phoneType == "Hospital") {
			ph = this.memberAppDataService.memberAppData.phones.hospitalphone;
		} else if (phoneType == "Business") {
			ph = this.memberAppDataService.memberAppData.phones.businessphone;
		} else if (phoneType == "Mobile") {
			ph = this.memberAppDataService.memberAppData.phones.cellphone;
		}
		return ph;
	}

	UpdateMemberAppData_Address(ca: CustomerAddress) {
		let addressType: string = ca.addresstype;
		if (addressType == "Home") {
			this.memberAppDataService.memberAppData.addresses.home = ca;
		} else if (addressType == "Hospital") {
			this.memberAppDataService.memberAppData.addresses.hospital = ca;
		} else if (addressType == "Business") {
			this.memberAppDataService.memberAppData.addresses.business = ca;
		}

		//Check and set intenrational
		this.memberAppDataService.SetInternational();

		//pga:coding-5865 update flag value on address changes
		this.memberAppDataService.SetUSOrCanada();
	}

	UpdateMemberAppData_Phones(phoneType: string, phone: string) {
		if (phoneType == "Home") {
			this.memberAppDataService.memberAppData.phones.homephone = phone;
		} else if (phoneType == "Hospital") {
			this.memberAppDataService.memberAppData.phones.hospitalphone = phone;
		} else if (phoneType == "Business") {
			this.memberAppDataService.memberAppData.phones.businessphone = phone;
		} else if (phoneType == "Mobile") {
			this.memberAppDataService.memberAppData.phones.cellphone = phone;
		}
	}

	savePersonalInformation(
		personalInformation: PersonalInformationDetails
	): HttpResponse<any> | any {
		let payload = {
			contactid: this.ssoService.contactid,
			personalinfo: personalInformation
		};
		return this.http
			.post(
				this.dataService.memberappapiendpoint +
					"UpdatePersonalInformation",
				JSON.stringify(payload)
			)
			.pipe(
				tap(d => {
					//Update addresses dataset in the MemberAppData
				})
			);
	}

	searchContact(token: string, tokenType: string) {
		let payload = { searchtext: token };
		let silentHeaders = new HttpHeaders({
			"X-silent": "true"
		});

		if (tokenType == "npi" && token.length < 10) {
			return of(null);
		}

		return this.http.post(
			this.dataService.contactapiendpoint + "SearchContact",
			JSON.stringify(payload),
			{ headers: silentHeaders }
		);
	}
}
